// toast notifications
import { toast } from "react-toastify";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Forms components
import { Formik, Form } from "formik";
import FormField from "../FormField";
import { form, initialValues, validations } from "./schemas/form";

// Data and functions
import { useUserContext } from "contexts/contextUser";
import { useUpdateBasicInfo } from "api/features/auth/queries";

function BasicInfo(): JSX.Element {
  const { formId, formField } = form;
  const { user_firstname, user_lastname, user_email, user_confirmationEmail } = formField;

  const { user } = useUserContext();

  const updateBasicInfoClient = useUpdateBasicInfo();

  const handleSubmit = async (values: any, actions: any) => {
    updateBasicInfoClient.mutate(
      {
        userId: user?.user_id,
        data: {
          email: values.user_email,
          firstname: values.user_firstname,
          lastname: values.user_lastname,
        },
      },
      {
        onSuccess: async () => {
          toast.success("User information updated successfully");
          actions.setSubmitting(false);
          actions.resetForm({ values: { ...values, user_confirmationEmail: "" } });
        },
        onError: (error: any) => {
          toast.error(`Error updating user information: ${error.message}`);
          actions.setSubmitting(false);
        },
      }
    );
  };

  return (
    <Card id="basic-info" sx={{ overflow: "visible" }}>
      <MDBox p={3}>
        <MDTypography variant="h5">Basic Info</MDTypography>
      </MDBox>
      <Formik
        initialValues={{ ...initialValues, ...(user || {}), user_confirmationEmail: "" }}
        validationSchema={validations}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, isSubmitting }) => (
          <Form id={formId} autoComplete="off">
            <MDBox pb={3} px={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type={user_firstname.type}
                    label={user_firstname.label}
                    name={user_firstname.name}
                    value={values.user_firstname}
                    placeholder={user?.user_firstname}
                    error={errors.user_firstname && touched.user_firstname}
                    success={values.user_firstname.length > 0 && !errors.user_firstname}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type={user_lastname.type}
                    label={user_lastname.label}
                    name={user_lastname.name}
                    value={values.user_lastname}
                    placeholder={user?.user_lastname}
                    error={errors.user_lastname && touched.user_lastname}
                    success={values.user_lastname.length > 0 && !errors.user_lastname}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type={user_email.type}
                    label={user_email.label}
                    name={user_email.name}
                    value={values.user_email}
                    placeholder={user?.user_email}
                    error={errors.user_email && touched.user_email}
                    success={values.user_email.length > 0 && !errors.user_email}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormField
                    type={user_confirmationEmail.type}
                    label={user_confirmationEmail.label}
                    name={user_confirmationEmail.name}
                    value={values.user_confirmationEmail}
                    placeholder={user?.user_email}
                    error={errors.user_confirmationEmail && touched.user_confirmationEmail}
                    success={
                      values.user_confirmationEmail.length > 0 && !errors.user_confirmationEmail
                    }
                    inputProps={{ autoComplete: "" }}
                  />
                </Grid>
                <Grid container item xs={12} justifyContent="flex-end">
                  <MDButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    disabled={
                      isSubmitting ||
                      Object.keys(errors).length > 0 ||
                      Object.keys(touched).length == 0
                    }
                    type="submit"
                  >
                    update info
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
          </Form>
        )}
      </Formik>
    </Card>
  );
}

export default BasicInfo;
